import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  /** Icon to display */
  icon?: LucideIcon
  /** Main heading text */
  title: string
  /** Description text */
  description?: string
  /** Optional action button */
  action?: {
    label: string
    icon?: LucideIcon
    onClick?: () => void
  }
  /** Custom content to render instead of default layout */
  children?: ReactNode
  /** Whether to wrap in a Card (default: true) */
  withCard?: boolean
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  children,
  withCard = true,
}: EmptyStateProps) {
  const ActionIcon = action?.icon

  const content = children || (
    <div className="text-center">
      {Icon && <Icon className="h-12 w-12 text-muted-foreground mx-auto mb-3" />}
      <p className="text-lg font-medium mb-2">{title}</p>
      {description && <p className="text-sm text-muted-foreground mb-4">{description}</p>}
      {action && (
        <Button onClick={action.onClick}>
          {ActionIcon && <ActionIcon className="mr-2 h-4 w-4" />}
          {action.label}
        </Button>
      )}
    </div>
  )

  if (!withCard) {
    return <div className="flex flex-col items-center justify-center py-12">{content}</div>
  }

  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        {content}
      </CardContent>
    </Card>
  )
}
